import { JetView, plugins } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the partner management view.
 * @extends JetView
 */
export default class partnerManagementView extends JetView {
    /**
     * Configures the layout of the partner management view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        return {
            type: 'wide',
            cols: [
                {
                    localId: 'inner:layout', // Local ID for inner layout
                    type: 'wide',
                    rows: [
                        {
                            view: 'toolbar', // Toolbar component
                            css: theme, // Apply theme CSS
                            elements: [
                                {
                                    width: 30,
                                    css: 'back-button', // CSS class for back button
                                    view: 'button', // Button component
                                    type: 'icon', // Button type
                                    icon: 'wxi-angle-left', // Icon for the button
                                    id: 'security.adminuser', // Button ID
                                    align: 'center', // Center alignment
                                    click: () => {
                                        // Click event handler
                                        this.show('../partner.PartnerSettings'); // Navigate to PartnerSettings
                                    },
                                },
                                {
                                    css: 'user-selected', // CSS class for label
                                    view: 'label', // Label component
                                    id: 'lblTittle', // Label ID
                                    align: 'center', // Center alignment
                                },
                            ],
                        },
                        {
                            view: 'tabbar', // Tabbar component
                            localId: 'tabbar', // Local ID for tabbar
                            id: 'tabbar', // Tabbar ID
                            height: 43, // Height of the tabbar
                            options: [
                                // Tab options
                                {
                                    id: 'partner.configuration', // Tab ID
                                    value: _('Configuración'), // Tab label
                                    hidden: !devConfig.getPermAction('partnerSettingsConfiguration', 'Add'), // Visibility based on permissions
                                    css: 'prm-partnerSettingsConfiguration', // CSS class for tab
                                },
                                {
                                    id: 'partner.products/partner.products.partnersProducts', // Tab ID
                                    value: _('Productos'), // Tab label
                                    hidden: !devConfig.getPermAction('partnerSettingsProducts', 'Add'), // Visibility based on permissions
                                    css: 'prm-partnerSettingsProducts', // CSS class for tab
                                },
                                {
                                    id: 'partner.products2/partner.products2.partnersProducts', // Tab ID
                                    value: _('Productos 2'), // Tab label
                                    hidden: !devConfig.getPermAction('partnerSettingsProducts2', 'Add'), // Visibility based on permissions
                                    css: 'prm-partnerSettingsProducts2', // CSS class for tab
                                },
                                {
                                    id: 'partner.reports/partner.reports.depositReport', // Tab ID
                                    value: _('Reportes'), // Tab label
                                    hidden: !devConfig.getPermAction('partnerSettingsReports', 'Add'), // Visibility based on permissions
                                    css: 'prm-partnerSettingsReports', // CSS class for tab
                                },
                                {
                                    id: 'partner.countries', // Tab ID
                                    value: _('Países'), // Tab label
                                    hidden: !devConfig.getPermAction('partnerSettingsCountries', 'Add'), // Visibility based on permissions
                                    css: 'prm-partnerSettingsCountries', // CSS class for tab
                                },
                                {
                                    id: 'partner.TRM', // Tab ID
                                    value: _('TRM'), // Tab label
                                    hidden: !devConfig.getPermAction('partnerSettingsTRM', 'Add'), // Visibility based on permissions
                                    css: 'prm-partnerSettingsTRM', // CSS class for tab
                                },
                                {
                                    id: 'partner.menusUser', // Tab ID
                                    value: _('Menús Usuarios'), // Tab label
                                    hidden: !devConfig.getPermAction('partnerSettingsMenusUser', 'Add'), // Visibility based on permissions
                                    css: 'prm-partnerSettingsMenusUser', // CSS class for tab
                                },
                                {
                                    id: 'partner.configurationSEO', // Tab ID
                                    value: _('Configuración SEO'), // Tab label
                                    hidden: !devConfig.getPermAction('partnerSettingsSEO', 'Add'), // Visibility based on permissions
                                    css: 'prm-partnerSettingsSEO', // CSS class for tab
                                },
                                {
                                    id: 'partner.configurationControl2', // Tab ID
                                    value: _('Control'), // Tab label
                                    hidden: !devConfig.getPermAction('partnerSettingsControl', 'Add'), // Visibility based on permissions
                                    css: 'prm-partnerSettingsControl', // CSS class for tab
                                },
                            ],
                        },
                        {
                            $subview: true, // Placeholder for subview
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the partner management view.
     */
    init() {
        this.use(plugins.Menu, {
            // Use menu plugin
            id: this.$$('tabbar'), // Reference to tabbar
            urls: {
                'partner.partnertManagement': 'partner.partnertManagement/partner.configuration', // URL mapping
            },
        });
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        const partners = profile.Partners; // Retrieve partners from profile

        /**
         * Filters partners based on the provided partner ID.
         * @param {Array} partners - The list of partners to filter.
         * @returns {Object} The filtered partner.
         */
        function filter_partners(partners) {
            return partners.id == id_partner; // Filter condition
        }

        var partner = partners.filter(filter_partners); // Apply filter to partners
        $$('lblTittle').setValue(
            // Set the value of the title label
            "<div class='username-active'><div style='font-weight: normal'>" +
                _('Partner') +
                ': &nbsp;</div><div>' +
                partner[0].value + // Display partner value
                '</div></div>',
        );
    }
}

// FILE DOCUMENTED
